import styled from '@emotion/styled';
import { MEDIA_QUERIES, SPACER } from 'radiance-ui/lib/constants';
import { LOCAL_COLORS, LOCAL_CONTENT_MAX_WIDTH } from 'styles/constants';
import { css } from '@emotion/react';

export const BeforeAfterPopContainer = styled.div<{
  backgroundColor?: string;
}>`
  background-color: ${({ backgroundColor }) =>
    backgroundColor ?? LOCAL_COLORS.surfaceWhite};
  padding: ${SPACER.xlarge} ${SPACER.medium} ${SPACER.large};

  ${MEDIA_QUERIES.mdUp} {
    padding: 80px ${SPACER.xlarge} ${SPACER.large};
  }

  ${MEDIA_QUERIES.xlUp} {
    padding: 100px 72px ${SPACER.large};
  }

  ${MEDIA_QUERIES.xxlUp} {
    padding: 120px 0 ${SPACER.large};
  }
`;

const persistentBrandedScrollbar = css`
  ${MEDIA_QUERIES.smUp} {
    scrollbar-color: ${LOCAL_COLORS.surfaceOrange};

    ::-webkit-scrollbar {
      height: 7px;
    }

    ::-webkit-scrollbar-track {
      background: ${LOCAL_COLORS.surfaceWhite};
      box-shadow: none;
    }

    ::-webkit-scrollbar-thumb {
      background-color: ${LOCAL_COLORS.surfaceOrange};
      height: 7px;
    }

    ::-webkit-scrollbar-button:start {
      display: block;
      background: transparent;
    }

    ::-webkit-scrollbar-button:end:increment {
      width: 100%;
      display: block;
      background: transparent;
    }
  }
`;

export const InnerBox = styled.div<{ singleExample: boolean }>`
  margin: auto;

  ${MEDIA_QUERIES.mdUp} {
    max-width: ${LOCAL_CONTENT_MAX_WIDTH};
    ${({ singleExample }) =>
      singleExample &&
      `display: flex; flex-direction: row; gap: ${SPACER.x2large};`};
  }
`;

export const Header = styled.h2`
  font-size: ${SPACER.large};
  font-weight: 700;
  line-height: 110%;
  letter-spacing: -0.64px;

  ${MEDIA_QUERIES.mdUp} {
    font-size: ${SPACER.xlarge};
  }

  ${MEDIA_QUERIES.xlUp} {
    font-size: 52px;
    max-width: 600px;
  }
`;

export const HeaderContent = styled.div<{ singleExample: boolean }>`
  .purple {
    color: ${LOCAL_COLORS.surfaceBrandBold};
  }

  padding-bottom: 32px;

  ${MEDIA_QUERIES.mdUp} {
    display: flex;

    ${({ singleExample }) =>
      singleExample
        ? `align-items: flex-start; flex-direction: column; padding-left: ${SPACER.large}; justify-content: space-around;`
        : 'align-items: flex-end; flex-direction: row; justify-content: space-between;'};

    > div {
      width: fit-content;
    }
  }
`;

export const SubheaderContent = styled.div`
  margin: 0 ${SPACER.medium} ${SPACER.x5large};

  ${MEDIA_QUERIES.mdUp} {
    align-items: flex-end;
    display: flex;
    margin: 0 0 ${SPACER.x5large};
    justify-content: space-between;

    > div {
      width: fit-content;
    }

    button {
      font-size: 16px;
      font-weight: 700;
      line-height: 132%;
      letter-spacing: -0.32px;
    }
  }
`;

export const Subheader = styled.div`
  font-size: 16px;
  line-height: 132%;

  ${MEDIA_QUERIES.mdUp} {
    font-size: 16px;
    max-width: 400px;
  }

  ${MEDIA_QUERIES.xlUp} {
    font-size: 24px;
    line-height: 140%;
    max-width: 600px;
  }
`;

export const ExamplesContainer = styled.div<{
  persistentScrollBar?: boolean;
  singleExample?: boolean;
}>`
  ${({ persistentScrollBar }) =>
    persistentScrollBar &&
    css`
      ${persistentBrandedScrollbar}
    `};
  ${({ singleExample }) =>
    singleExample
      ? `justify-content: center; padding: ${SPACER.medium} 0;`
      : `overflow-x: scroll; padding: 0 0 ${SPACER.medium}; margin-bottom: ${SPACER.xlarge};`};

  display: flex;
  scrollbar-color: ${LOCAL_COLORS.surfaceOrange};

  ${MEDIA_QUERIES.mdUp} {
    ${({ singleExample }) =>
      singleExample ? 'min-width: 400px;' : `min-width: unset; `}
  }
`;

export const Disclaimer = styled.small`
  font-size: 14px;
  line-height: 140%;
  margin: ${SPACER.medium};

  ${MEDIA_QUERIES.mdUp} {
    margin: ${SPACER.medium} 0;
  }
`;

export const QuoteSummary = styled.div`
  h2 {
    font-size: 16px;
    font-weight: 700;
    margin-top: ${SPACER.large};
  }

  h6 {
    font-size: 12px;
  }
`;
